<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-app id="selectLanguage">
                <tool-bar>
                    <slot><h3>{{selected_condition}}</h3></slot>
                </tool-bar>

                <v-content class="pt-0">
                    <v-container fill-height fluid>
                        <v-layout justify-center>
                            <v-card>
                                <v-toolbar class="elevation-0" color="none">
                                    <v-toolbar-title>
                                        <b class="text-primary">Dear {{extendConvertVisaDetail.full_name}} , please
                                            confirm your
                                            information:</b>
                                    </v-toolbar-title>
                                    <v-spacer/>
                                </v-toolbar>

                                <v-card-text class="pt-0">
                                    <v-layout row style="background: #ffffff" wrap>
                                        <form-error-display-handler :errors="errors"/>

                                        <v-flex class="mx-2" xs12>
                                          <late-info-message :overstay="1" v-if="extendConvertData.hasOwnProperty('is_special_overstay_regulation')"/>
                                          <late-info-message :convert="true" v-else/>
                                        </v-flex>

                                        <confirmation-header-text text="Conversion Details"
                                                                  class="ml-2"
                                                                  icon="mdi-equal-box"/>

                                        <v-flex sm3 xs12>
                                            <list-item-detail
                                                    :sub_title="extendConvertData.days_staying + ' days ('+visaPlan.value+')'"
                                                    :title="$vuetify.lang.t('$vuetify.visa_duration')"/>
                                        </v-flex>

                                        <v-flex sm3 xs12>
                                            <list-item-detail
                                                    :sub_title="extendConvertData.start_date + ' to '+ expiry_date"
                                                    :title="$vuetify.lang.t('$vuetify.visa_period')"/>
                                        </v-flex>
                                        <v-flex sm3 xs6>
                                            <list-item-detail :sub_title="extendConvertData.purpose_of_visa"
                                                              :title="$vuetify.lang.t('$vuetify.reason_for_convert')"/>
                                        </v-flex>
                                      <v-flex sm3 xs6>
                                        <list-item-detail :sub_title="visaPlan.value"
                                                          :title="$vuetify.lang.t('$vuetify.visa_plan')"/>
                                        </v-flex>
                                        <v-flex sm3 xs6>
                                            <list-item-detail :sub_title="selected_condition"
                                                              :title="$vuetify.lang.t('$vuetify.visa_type_condition')"/>
                                        </v-flex>
                                        <v-flex sm3 xs6 v-if="!extendConvertData.hasOwnProperty('is_special_overstay_regulation')">
                                            <list-item-detail :sub_title="'$ '+extendConvertData.cost"
                                                              title="Visa Fee"/>
                                        </v-flex>
                                        <v-flex sm3 xs6 v-if="!extendConvertData.hasOwnProperty('is_special_overstay_regulation')">
                                            <list-item-detail :sub_title="'$ '+ late_fee"
                                                              title="Late Fee"/>
                                        </v-flex>
<!--                                        <v-flex sm3 xs6>-->
<!--                                            <list-item-detail :sub_title="'$ '+extendConvertData.cost"-->
<!--                                                              title="Penalty"/>-->
<!--                                        </v-flex>-->
                                        <v-flex sm3 xs6 v-if="!extendConvertData.hasOwnProperty('is_special_overstay_regulation')">
                                            <list-item-detail :sub_title="'$ '+total_cost"
                                                              :title="$vuetify.lang.t('$vuetify.total_cost')"/>
                                        </v-flex>
                                      <v-flex sm3 xs6>
                                        <list-item-detail :sub_title="extendConvertData.mobile_number"
                                                          title="Mobile Number" />
                                      </v-flex>
                                      <v-flex sm3 xs6>
                                        <list-item-detail :sub_title="extendConvertData.email" title="Email"/>
                                      </v-flex>

                                        <v-flex sm12 xs12  class="mx-2 pt-3" v-if="extendConvertData.hasOwnProperty('is_special_overstay_regulation')">
                                          <v-alert outlined type="info" v-if="extendConvertData.special_overstay_regulation_condition == 'business-working-conversion'">
                                            साविकमा पर्यटक भिसामा १५० दिन भित्रै गैर पर्यटक (कार्य सहमति)/ व्यवसायिक भिसा  थपका लागि कार्य प्रकृया अगाडि बढाएका तर प्रकृयागत ढिलाईले १५० दिन पश्चात भिसाका लागि अध्यागमन विभागमा उपस्थित भएकाहरुमध्ये माग बमोजिमको भिसा लिन पाउने ठहरिएका विदेशी नागरिकहरुलाई १५० दिन भन्दा बढि अवधिको पर्यटक भिसा शुल्क, विलम्ब शुल्क र जरिवाना समेत लिई १५१ औ दिन देखि पर्यटक भिसाको शुल्क तिरेको अवधिसम्मको निःशुल्क गैरपर्यटक (Working)/व्यवसायिक भिसा जारी गर्ने तत्पश्चात सिफारिस बमोजिमको अवधिसम्म नियमानुसार भिसा शुल्क लिई वा संझौता अनुसार जारी गर्ने ।
                                          </v-alert>
                                          <v-alert outlined type="info" v-else-if="extendConvertData.special_overstay_regulation_condition == 'relation-marriage-extension'">
                                            गैर पर्यटक भिसा लिएका  तर एक वर्ष भन्दा ....
                                          </v-alert>
                                        </v-flex>

                                        <v-flex v-if="showDocuments" xs12>
                                            <v-divider class="my-3"/>
                                        </v-flex>

                                        <confirmation-header-text
                                                class="ml-2"
                                                icon="mdi-file-document"
                                                text="Documents need to be submitted"
                                                v-if="showDocuments"
                                        />

                                        <v-flex xs12>
                                            <v-layout class="mx-0" row wrap>
                                                <v-flex :key="document.id"
                                                        v-for="(document,index) in extendConvertData.documents"
                                                        xs12>
                                                    <v-alert :icon="false"
                                                             dense
                                                             outlined
                                                             type="info"
                                                    >
                                                        {{index+1}}. {{document.name}}
                                                        {{document.required?"(Required)":""}}
                                                    </v-alert>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

	                                    <v-flex v-if="extendConvertData.required_documents" xs12>
		                                    <v-divider class="my-3"/>
	                                    </v-flex>

	                                    <identity-documents
			                                    v-if="extendConvertData.required_documents && extendConvertData.required_documents.length > 0"
			                                    class="mx-6"
			                                    :documents="extendConvertData.required_documents"
			                                    headerText="Identify Documents"
	                                    />

                                        <v-flex ml-4 v-if="extraPassport.country" xs12>
                                            <h4>Extra Passport Detail</h4>
                                        </v-flex>


                                        <v-flex sm3 v-if="extraPassport.country" xs6>
                                            <list-item-detail :sub_title="extraPassport.country"
                                                              :title="$vuetify.lang.t('$vuetify.country')">
                                            </list-item-detail>
                                        </v-flex>

                                        <v-flex sm3 v-if="extraPassport.number" xs6>
                                            <list-item-detail :sub_title="extraPassport.number"
                                                              :title="$vuetify.lang.t('$vuetify.passport_number')">
                                            </list-item-detail>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-divider class="my-3"/>
                                        </v-flex>

                                        <v-flex xs12>
                                            <component v-bind:is="selected_visa_type"/>
                                        </v-flex>

                                        <v-flex class="pt-0 px-0" xs12>
                                            <visa-detail :visa="extendConvertVisaDetail"
                                                         header-text="Current Visa Details"/>
                                        </v-flex>


                                        <v-flex xs12>
                                            <v-divider class="my-3" v-if="showDocuments"/>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-btn
                                                    v-if="extendConvertData.is_special_overstay_regulation"
                                                    :loading="loading"
                                                    @click="proceedOverstayedConvertVisa"
                                                    class="pull-right mr-2"
                                                    color="primary "
                                                    large>
                                                Submit
                                            </v-btn>
                                            <v-btn
                                                  v-else
                                                  :loading="loading"
                                                  @click="proceedConvertVisa"
                                                  class="pull-right mr-2"
                                                  color="primary "
                                                  large>
                                                Submit
                                            </v-btn>
                                            <v-btn
                                                    @click="backBtnClicked()"
                                                    class="pull-right mr-2"
                                                    color="error"
                                                    large>
                                                {{$vuetify.lang.t('$vuetify.back')}}
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-layout>
                    </v-container>
                </v-content>
            </v-app>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import VisaDetail from "../VisaDetail";
    import BusinessVisa from '../../components/visa/confirm/BusinessVisa'
    import DependentVisa from '../../components/visa/confirm/DependentVisa'
    import MarriageVisa from '../../components/visa/confirm/MarriageVisa'
    import NRNVisa from '../../components/visa/confirm/NRNVisa'
    import RelationVisa from '../../components/visa/confirm/RelationVisa'
    import ResidentialVisa from '../../components/visa/confirm/ResidentialVisa'
    import StudyVisa from '../../components/visa/confirm/StudyVisa'
    import TouristVisa from '../../components/visa/confirm/TouristVisa'
    import TransitVisa from '../../components/visa/confirm/TransitVisa'
    import WorkingVisa from '../../components/visa/confirm/WorkingVisa'
    import PressVisa from '../../components/visa/confirm/PressVisa'
    import FileListItemDetail from '../../components/FileListItemDetail'
    import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
    import ListItemDetail from '../../components/ListItemDetail'
    import ToolBar from '../../components/ToolBar'
    import FileDisplay from '../../components/FileDisplay'
    import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
    import ReciprocityVisa from "../../components/visa/confirm/ReciprocityVisa";
    import LateInfoMessage from "../../components/LateInfoMessage";
    import moment from "moment";
    import {VISA_PLANS} from "../../constant/appConstant";
    import IdentityDocuments from "../../components/IdentityDocuments";

    export default {
        name: "VisaExtendConvertConfirm",
        components: {
	        IdentityDocuments,
            LateInfoMessage,
            FormErrorDisplayHandler,
            VisaDetail,
            "marriage-visa": MarriageVisa,
            "dependent-visa": DependentVisa,
            "nrn-visa": NRNVisa,
            "relation-visa": RelationVisa,
            "residential-visa": ResidentialVisa,
            "study-visa": StudyVisa,
            "tourist-visa": TouristVisa,
            "transit-visa": TransitVisa,
            "file-display": FileDisplay,
            "working-visa": WorkingVisa,
            "business-visa": BusinessVisa,
            "press-visa": PressVisa, FileListItemDetail,
            ReciprocityVisa,
            ConfirmationHeaderText, ListItemDetail, ToolBar
        },
        data() {
            return {
                background: require("@/assets/background.jpg"),
                visa_plans: VISA_PLANS,
                errors: []
            }
        },
        // beforeRouteEnter(to, from, next) {
        //
        //     if (!from.name || from.name === 'PrintForm') {
        //         next(vm => {
        //             vm.$router.push({
        //                 name: 'ExtendChangeVisa'
        //             })
        //         })
        //     }
        //     next();
        // },
        methods: {
            ...mapActions({
                submitVisaExtend: "VisaSingle/submitExtendVisa",
                submitConvertVisa: "VisaSingle/submitConvertVisa",
                submitOverstayedConvertVisa: "VisaSingle/submitOverstayedConvertVisa",
            }),
            backBtnClicked() {
                this.$router.go(-1);
            },
            proceedConvertVisa() {
                this.submitConvertVisa().then((res) => {
                    // this.$store.commit("VisaSingle/resetState");
                    this.$store.commit("VisaSingle/setPrintResponse", res.data);
                    this.$router.push({
                        name: 'PrintForm'
                    })
                }).catch((err) => {
                    if (err.response.status === 422 || err.response.status === 400) {
                        this.$store.commit('Notification/showError', err.response.data.message);
                        this.errors = err.response.data.errors;
                    }
                })
            },
            proceedOverstayedConvertVisa() {
                this.submitOverstayedConvertVisa().then((res) => {
                    this.$store.commit("VisaSingle/setPrintResponse", res.data);
                    this.$router.push({
                        name: 'PrintForm'
                    })
                }).catch((err) => {
                    if (err.response.status === 422 || err.response.status === 400) {
                        this.$store.commit('Notification/showError', err.response.data.message);
                        this.errors = err.response.data.errors;
                    }
                })
            }
        },
        computed: {
            ...mapGetters('VisaSingle', ['visa', 'convert_visa_options', 'extra_data', 'visaCatOptions', 'extendConvertData', 'extraPassport', 'dependentVisaDetail', 'extendConvertVisaDetail', 'loading']),
            ...mapGetters('VisaType', ['conditions', 'border_case_extend_condition','visa_type_slug','late_cost']),
            selected_condition() {
                if (!this.isDependent) {
                  let conditions = this.$store.state.VisaType.borderCaseReachedDay > 0 ? this.border_case_extend_condition : this.conditions;
                  let condition = conditions.find((i) => i.id === (this.$store.state.VisaType.borderCaseReachedDay > 0  ? this.extendConvertData.border_condition : this.extendConvertData.condition));
                  return condition.name;
                }
                return 'Dependent visa';
            },
            visaPlan() {
                return this.visa_plans.find((i) => parseInt(i.key) === parseInt(this.extendConvertData.visaPlan));
            },
            showDocuments() {
                return this.visa_type_slug !== 'tourist-visa';
            },
            selected_visa_type() {
                let convert_option = this.convert_visa_options.find((i) => i.id === this.extendConvertData.visa_type);
                if (convert_option) {
                    return convert_option.slug;
                }

                return null;
            },
            isDependent(){
                let convert_option = this.convert_visa_options.find((i) => i.id === this.extendConvertData.visa_type);
                if (convert_option !== undefined && convert_option.dependent) {
                    return true;
                }

                return false;
            },
            expiry_date() {
                return moment(this.extendConvertData.start_date).add(this.extendConvertData.days_staying, 'days').subtract(1, 'days').format('YYYY-MM-DD');
            },
            total_cost() {
                let cost = parseInt(this.extendConvertData.cost);
                if (cost > 0) {
                    cost += this.late_cost
                }
                return cost;
            },
            late_fee() {
                return this.late_cost;
            }
        }
    }
</script>
